import i18n from '@/i18n';
import { dateSortFunction } from '@/tools/functions';
import { CellType, DataType, FilterType } from '@colven/common-domain-lib/lib';

export const TRACK_STATUS_HEADERS = [
    {
        text: i18n.t('trackStatus.table.unitId'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'unitID',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('trackStatus.table.trackTimestamp'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        cellType: CellType.textBackgroundColor,
        cellConfig: {
            round: false,
            outlined: true,
            color: 'trackTimestampColor'
        },
        value: 'trackTimestampString',
        spinner: false,
        width: 200,
        sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') }
    },
    {
        text: i18n.t('trackStatus.table.timestamp'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        cellType: CellType.textBackgroundColor,
        cellConfig: {
            round: false,
            outlined: true,
            color: 'timestampColor'
        },
        value: 'timestampString',
        spinner: false,
        width: 200,
        sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') }
    },
    {
        text: i18n.t('trackStatus.table.data'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'data',
        spinner: false,
        width: 200,
    }
]